<div class="terms-and-conditions-detail-container">
    <div class="nav-container">
        <button class="btn link-btn btn-back">
            <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectTermsAndConditions()"></i>
        </button>
        <span class="fw-semibold ms-3">{{'termsAndConditions.add.addTermsAndConditionsNavLabel' | translate}}</span>
    </div>

    <form #form="ngForm">
        <div class="form-input-container">
            <div class="row justify-content-center mb-3 flex-wrap">
                <div class="col-md-4 col-lg-5 col-xxl-4 col-xxxl-3 align-content-lg-start flex-wrap h-100">
                    <div class="mb-4">
                        <div class="label-input">{{'termsAndConditions.cookieMessageTitle' | translate}}<span class="text-primary fw-bold"> *</span></div>
                        <input 
                            [disabled]="isCookieEditable()"
                            class="text-input"
                            kendoTextBox
                            name="title"
                            #title="ngModel"
                            type="text"
                            placeholder="{{ 'termsAndConditions.add.placeholder.cookieMessageTitle' | translate }}"
                            [(ngModel)]="cookie.title" 
                            [value]="cookie.title"
                            [ngClass]="{'form-submitted': form.submitted}"
                            required
                            pattern="^.{0,100}$"
                            >
    
                        <div class="error-info" *ngIf="title.invalid  && (title.dirty || title.touched || form.submitted)">
                            <div *ngIf="title.errors?.['required']" >
                                {{'common.validation.required' | translate}}
                            </div>
                            <div *ngIf="title.errors?.['pattern']" >
                                {{'common.validation.titleTooLong' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="label-input">{{'termsAndConditions.startDate' | translate}}<span class="text-primary fw-bold"> *</span></div>
                        <kendo-datepicker HJSuppress
                            [disabled]="isCookieEditable()"
                            [(ngModel)]="startDate" 
                            [value] = "startDate"
                            [ngClass]="{'form-submitted': form.submitted}"
                            name="startDate"
                            (ngModelChange)="changeStartDateDatePicker()"
                            #startDateInput
                            class="custom-kendo-control-xl"
                            [fillMode]="fillModeOutline"
                            [rounded]="roundedLarge"    
                            (click)="!startDateInput.isOpen ? startDateInput.toggle() : null"
                            [popupSettings]="{popupClass : 'data-hj-suppress'}"
                            required
                            [disabledDates]="disabledDates"
                            #startDateModel = "ngModel"
                        >
                            <kendo-datepicker-messages
                                today="{{ 'calendar.today' | translate }}"
                                toggle="{{ 'calendar.toggle' | translate }}"
                            >
                            </kendo-datepicker-messages>
                        </kendo-datepicker> 
                        <div class="error-info" *ngIf="startDateModel.invalid  && (startDateModel.dirty || startDateModel.touched || form.submitted)">
                            <div *ngIf="startDateModel.errors?.['required']" >
                                {{'common.validation.required' | translate}}
                            </div>
                        </div>
                    </div>
                    <div class="mb-4 mb-md-0">
                        <div class="label-input d-flex">{{'termsAndConditions.required' | translate}}<span class="text-primary fw-bold"> *</span>    
                            <i class="app-icon icon icon-warning-circle info-tooltip-trigger ms-1 align-self-center" 
                                [ngbTooltip]="requiredInfoTooltip">
                            </i> 
                        </div>
                        <div [ngClass]="{ active: cookie.required }"
                            class="radio-container">
                            <input kendoRadioButton
                                [disabled]="isCookieEditable()"
                                id="isRequired"
                                [(ngModel)]="cookie.required" 
                                name="cookie.required"
                                type="radio"
                                [value]="true"
                            >
                            <label for="isRequired" class="radio-label fw-bold"   
                                [ngClass]="{'disabled': isCookieEditable()}">
                                {{'termsAndConditions.isRequired' | translate}}
                            </label>
                        </div>
                        <div [ngClass]="{ active: !cookie.required }" 
                            class="radio-container">
                            <input kendoRadioButton
                                [disabled]="isCookieEditable()"
                                id="isNotRequired"
                                [(ngModel)]="cookie.required" 
                                name="cookie.required"
                                type="radio"
                                [value]="false"
                            >
                            <label for="isNotRequired" class="radio-label fw-bold"
                                [ngClass]="{'disabled': isCookieEditable()}">
                                {{'termsAndConditions.isNotRequired' | translate}}
                            </label>
                        </div>
                    </div>          
                </div>
                <div class="d-flex flex-column col-md-8 col-lg-7 col-xxl-8 col-xxxl-9">
                    <div class="label-input">{{'termsAndConditions.add.message' | translate}}<span class="text-primary fw-bold"> *</span></div>
                        <kendo-editor class="flex-grow-1 kendo-editor-resizable-vertical" 
                            [disabled]="isCookieEditable()"
                            [iframe]="false"
                            [resizable]="resizable"
                            name="message"
                            (focus)="isEditorFocused = true"
                            (blur)="isEditorFocused = false"
                            [ngClass]="{'editor-focus': isEditorFocused, 'form-submitted': form.submitted }"
                            #message 
                            [(ngModel)]="cookie.message" 
                            #messageModel = "ngModel"
                            required> </kendo-editor>
                        <div class="error-info" *ngIf="messageModel.invalid  && (messageModel.dirty || messageModel.touched || form.submitted)">
                            <div *ngIf="messageModel.errors?.['required']" >
                                {{'common.validation.required' | translate}}
                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center" *ngIf="!isCookieEditable()">
            <button class="btn primary-btn px-4" (click)="saveCookieHandler()" [disabled]="loading">
                <span>{{'termsAndConditions.add.saveBtn' | translate}}</span>
            </button>
        </div>
    </form>
</div>

<ng-template #requiredInfoTooltip>
    {{ "termsAndConditions.add.requiredInfoTooltip" | translate }}
  </ng-template>